// src/pages/LoginPage.jsx
import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import LoginForm from "../components/Login";

const LoginPage = () => {
  return (
    <>
      <Header />
      <LoginForm />
      <Footer />
    </>
  );
};

export default LoginPage;
